import React, { useContext } from 'react';
import {
  returnMonthNameswithKeys,
  returnMonthList,
} from '../../../utils/consts/months';
import { Utility } from './utils';
import { LocaleSettingContext } from '../../../utils/consts/localeSetting';
import { change__proto__ } from '../../../utils/utility/prototypeModifier';
import { ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon } from '~svg/index';

function ButtonSection({
  monthIndex,
  onClick,
  changeDisplay,
  display,
  isDarkMode,
}) {
  const localState = JSON.parse(localStorage.getItem('state'));
  const { direction, timeZone } = useContext(LocaleSettingContext),
    { month, year } = Utility.currentDate(
      monthIndex,
      direction,
      timeZone,
      localState?.language?.name,
    );
  change__proto__.call(ButtonSection, 'languageDir', direction);
  return (
    <div
      className="col p-0 d-flex flex-row py-2 text-white"
      style={{ background: isDarkMode ? '#2b3057' : '#efefef' }}
    >
      <ButtonSection.Button
        direction={ButtonSection.languageDir == 'ltr' ? 'left' : 'right'}
        onClick={onClick.bind(null, 'previous')}
        isDarkMode={isDarkMode}
      />
      <ButtonSection.DateHeader
        {...{ month, year, changeDisplay, display, isDarkMode }}
      />
      <ButtonSection.Button
        direction={ButtonSection.languageDir == 'ltr' ? 'right' : 'left'}
        onClick={onClick.bind(null, 'next')}
        isDarkMode={isDarkMode}
      />
    </div>
  );
}
ButtonSection.createCustomProto({
  Button: function ({ direction, onClick, isDarkMode = false }) {
    return (
      <div
        onClick={onClick}
        className={`col-1 p-0 d-flex justify-content-center align-items-center cursor-pointer`}
      >
        {direction === 'left' ? (
          <ChevronLeftIcon
            size={16}
            color={isDarkMode ? '#cbd3da' : ' #00798c'}
          />
        ) : (
          <ChevronRightIcon
            size={16}
            color={isDarkMode ? '#cbd3da' : '#00798c'}
          />
        )}
      </div>
    );
  },

  DateHeader: function ({ month, year, changeDisplay, display, isDarkMode }) {
    const localState = JSON.parse(localStorage.getItem('state'));
    const monthOpt = ButtonSection.createOption('month', display),
      yearOpt = ButtonSection.createOption(
        'year',
        display,
        ' font-weight-bold',
      );
    return (
      <div className="col-10 d-flex justify-content-center align-items-center">
        <div className="text-secondary d-flex justify-content-center align-items-center py-1">
          <ButtonSection.HeaderItem
            onClick={changeDisplay.bind(null, monthOpt.display)}
            className={monthOpt.className}
            isDarkMode={isDarkMode}
          >
            {localState?.language?.name === 'ar'
              ? `${returnMonthNameswithKeys('miladi', 'ar', parseInt(month))}`
              : `${
                  returnMonthList(
                    localState?.language?.name === 'fa' ? 'rtl' : 'ltr',
                  )?.[month - 1]?.Name?.split(' ')?.[1] ?? ''
                }`}
          </ButtonSection.HeaderItem>
          <ButtonSection.HeaderItem
            onClick={changeDisplay.bind(null, yearOpt.display)}
            className={yearOpt.className}
            isDarkMode={isDarkMode}
          >
            {year}
          </ButtonSection.HeaderItem>
        </div>
      </div>
    );
  },

  HeaderItem: function ({ onClick, className, children, isDarkMode }) {
    return (
      <div className="text-center px-2  cursor-pointer" onClick={onClick}>
        <a
          className={`font-large ${className} ${
            isDarkMode
              ? ' text-white top-calendar-header-dark'
              : ' top-calendar-header'
          }`}
        >
          {children}
        </a>
        <span className="px-1 position-absolute">
          <ChevronDownIcon size={16} color="#f5f7fb" />
        </span>
      </div>
    );
  },

  createOption: function (type, display, className = '') {
    if (display == type) {
      display = 'date';
      className += ' selected';
    } else {
      display = type;
      className += '';
    }
    return { display, className };
  },
});

export { ButtonSection };
